module.exports = __webpack_public_path__ + "img/ca.86923e29.svg";